var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LegoModalLayout',{attrs:{"title":_vm.process}},[(_vm.processLowercase == 'validar')?_c('LegoAuditoria',{attrs:{"cardId":_vm.cardId}}):(_vm.processLowercase == 'adjuntos')?_c('LegoAdjuntos',{attrs:{"cardId":_vm.cardId}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }